import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { DestinationsPage } from '../../pages/destinations';
import { destinationFiltersToSearch, parseDestinationFilters } from '../../entities/destination';

export const Route = createFileRoute('/_shell/destinations/')({
  validateSearch: (search: Record<string, unknown>) => search,
  component: function DestinationsRoute() {
    const navigate = useNavigate();
    const filters = parseDestinationFilters(Route.useSearch());

    return (
      <DestinationsPage
        filters={filters}
        onFilters={(next) =>
          void navigate({ to: '/destinations', search: destinationFiltersToSearch(next) })
        }
        onOpen={(destination) =>
          void navigate({
            to: '/destinations/$destinationId',
            params: { destinationId: destination.id },
          })
        }
      />
    );
  },
});
